import React, { FunctionComponent, useMemo } from 'react';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { ContextProps } from 'reviews2/feed/review-yeti/Review.types';

import 'reviews2/feed/review-yeti/source/ReviewSource.scss';

export const ReviewSource: FunctionComponent<ContextProps> = ({ context }) => {
    const { review } = context;
    const { showSource, sourceOptions } = context.options!;
    const logoPath = useMemo((): string | undefined => {
        if (sourceOptions?.logo) {
            return sourceOptions.logo;
        }

        if (review!.source?.review?.logo) {
            return review!.source.review.logo;
        }

        return review!.source?.largeIconPath;
    }, [review, sourceOptions]);

    if (!showSource) {
        return null;
    }

    return (
        <div className="r4e-review-source">
            <a target="_blank" rel="noopener noreferrer" href={review.activity_url}>
                <OverlayTrigger overlay={<Tooltip id={review!.document_id}>{review!.source?.name}</Tooltip>}>
                    <img src={logoPath} alt={review!.source?.name} />
                </OverlayTrigger>
            </a>
        </div>
    );
};
